import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map, switchMap, tap, withLatestFrom, filter, catchError } from 'rxjs/operators';
import { EMPTY } from 'rxjs';
import { signIn, signInSuccess } from '../actions/auth.actions';
import { GeneralSettingsService } from '../../core/services/api/general-settings.service';
import { AppFormatSettingsService } from '@sukna/shared';
import { ROOT_EFFECTS_INIT } from '@ngrx/effects';

@Injectable()
export class AuthEffects {
  private actions$ = inject(Actions);
  private store = inject(Store<{ auth: { user: unknown } }>);
  private generalSettings = inject(GeneralSettingsService);
  private formatSettings = inject(AppFormatSettingsService);

  signIn$ = createEffect(() =>
    this.actions$.pipe(
      ofType(signIn),
      map((action) => signInSuccess({ response: action.response }))
    )
  );

  /** Load general settings when user is available (after sign-in success). */
  loadGeneralSettingsOnSignIn$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(signInSuccess),
        switchMap(() =>
          this.generalSettings.getGeneralSettings().pipe(
            tap((res: any) => {
              if (res && (res.dateFormat != null || res.timeFormat != null || res.timezone != null || res.weekStartDay != null)) {
                this.formatSettings.setSettings({
                  dateFormat: res.dateFormat,
                  timeFormat: res.timeFormat,
                  timezone: res.timezone,
                  weekStartDay: res.weekStartDay,
                });
              }
            }),
            catchError(() => EMPTY)
          )
        )
      ),
    { dispatch: false }
  );

  /** Load general settings on app init when user is already in store (e.g. rehydrated from localStorage). */
  loadGeneralSettingsOnInitIfUserAvailable$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROOT_EFFECTS_INIT),
        withLatestFrom(this.store.select((s: any) => s.auth?.user)),
        filter(([, user]) => user != null),
        switchMap(() =>
          this.generalSettings.getGeneralSettings().pipe(
            tap((res: any) => {
              if (res && (res.dateFormat != null || res.timeFormat != null || res.timezone != null || res.weekStartDay != null)) {
                this.formatSettings.setSettings({
                  dateFormat: res.dateFormat,
                  timeFormat: res.timeFormat,
                  timezone: res.timezone,
                  weekStartDay: res.weekStartDay,
                });
              }
            }),
            catchError(() => EMPTY)
          )
        )
      ),
    { dispatch: false }
  );
}
